/*eslint-disable */
import ENVS from "../constants/env"

export const getEnv = () => {
    if(process.env.REACT_APP_GATEWAY_API_BASEPATH.includes("dev")) {
        return ENVS.DEV
    }
    if(process.env.REACT_APP_GATEWAY_API_BASEPATH.includes("test")) {
        return ENVS.STAGE
    }
    if(process.env.REACT_APP_GATEWAY_API_BASEPATH.includes("prod")) {
        return ENVS.PRODUCTION
    }
}
